import { axiosInterceptor } from "../authInterceptor";
import environment from "../../../../environments/environment";



export async function saveUserProfile(UserId: any, VO: any) {
    try {
        const response = await axiosInterceptor.patch(`${environment.deleteUserURL}${UserId}`, VO);
        return response;
    } catch (error) {
        console.error('There was an error saving the theme setting!', error);
        throw error;
    }
}